export default [
  {
    id: 91,
    value: '软件',
    children: [
      {
        id: 9104,
        value: '效率办公',
        children: [
          {
            id: 910401,
            value: '邮箱'
          },
          {
            id: 910402,
            value: '备忘'
          },
          {
            id: 910403,
            value: '移动办公'
          },
          {
            id: 910404,
            value: '备份/存储'
          },
          {
            id: 910405,
            value: '文件管理'
          },
          {
            id: 910406,
            value: '文件扫描'
          },
          {
            id: 910407,
            value: '会议'
          },
          {
            id: 910408,
            value: 'CRM'
          }
        ]
      },
      {
        id: 9105,
        value: '教育培训',
        children: [
          {
            id: 910501,
            value: '网络课程'
          },
          {
            id: 910502,
            value: '习题解答'
          },
          {
            id: 910503,
            value: '词典/翻译'
          },
          {
            id: 910504,
            value: '少儿教育'
          },
          {
            id: 910505,
            value: '学历类'
          },
          {
            id: 910506,
            value: '职业/技能类'
          },
          {
            id: 910507,
            value: '语言类'
          },
          {
            id: 910508,
            value: '艺术类'
          },
          {
            id: 910509,
            value: '学科'
          }
        ]
      },
      {
        id: 9106,
        value: '旅游出行',
        children: [
          {
            id: 910601,
            value: '酒店'
          },
          {
            id: 910602,
            value: '综合旅游服务'
          },
          {
            id: 910603,
            value: '自驾游'
          },
          {
            id: 910604,
            value: '邮轮/游轮'
          },
          {
            id: 910605,
            value: '交通方式'
          },
          {
            id: 910606,
            value: '信息交流'
          },
          {
            id: 910607,
            value: '攻略'
          },
          {
            id: 910608,
            value: '辅助工具'
          }
        ]
      },
      {
        id: 9107,
        value: '交通导航',
        children: [
          {
            id: 910701,
            value: '出行服务'
          },
          {
            id: 910702,
            value: '信息查询'
          }
        ]
      },
      {
        id: 9108,
        value: '金融理财',
        children: [
          {
            id: 910801,
            value: '保险'
          },
          {
            id: 910802,
            value: '借贷'
          },
          {
            id: 910803,
            value: '理财'
          },
          {
            id: 910804,
            value: 'P2P'
          },
          {
            id: 910805,
            value: '银行'
          },
          {
            id: 910806,
            value: '彩票'
          },
          {
            id: 910807,
            value: '理财工具'
          }
        ]
      },
      {
        id: 9109,
        value: '网络购物',
        children: [
          {
            id: 910901,
            value: '商城'
          },
          {
            id: 910902,
            value: '导购'
          },
          {
            id: 910903,
            value: '团购'
          },
          {
            id: 910904,
            value: '海淘'
          },
          {
            id: 910905,
            value: '返利'
          }
        ]
      },
      {
        id: 9110,
        value: '汽车',
        children: [
          {
            id: 911001,
            value: '购车'
          },
          {
            id: 911002,
            value: '二手车'
          },
          {
            id: 911003,
            value: '汽车养护'
          },
          {
            id: 911004,
            value: '汽车资讯'
          }
        ]
      },
      {
        id: 9111,
        value: '服装鞋帽'
      },
      {
        id: 9112,
        value: '手机数码'
      },
      {
        id: 9113,
        value: '个护美妆',
        children: [
          {
            id: 911301,
            value: '护肤/彩妆'
          },
          {
            id: 911302,
            value: '美发'
          },
          {
            id: 911303,
            value: '美甲'
          }
        ]
      },
      {
        id: 9114,
        value: '食品餐饮',
        children: [
          {
            id: 911401,
            value: '团购优惠'
          },
          {
            id: 911402,
            value: '订餐/外卖'
          },
          {
            id: 911403,
            value: '菜谱'
          },
          {
            id: 911404,
            value: '餐饮资讯'
          }
        ]
      },
      {
        id: 9115,
        value: '母婴',
        children: [
          {
            id: 911501,
            value: '母婴用品'
          },
          {
            id: 911502,
            value: '母婴知识及服务'
          }
        ]
      },
      {
        id: 9116,
        value: '医疗健康',
        children: [
          {
            id: 911601,
            value: '中医'
          },
          {
            id: 911602,
            value: '药品/药店'
          },
          {
            id: 911603,
            value: '疾病咨询'
          },
          {
            id: 911604,
            value: '女性生理健康'
          },
          {
            id: 911605,
            value: '科室'
          }
        ]
      },
      {
        id: 9117,
        value: '体育',
        children: [
          {
            id: 911701,
            value: '运动健康'
          },
          {
            id: 911702,
            value: '体育项目'
          },
          {
            id: 911703,
            value: '体育资讯'
          }
        ]
      },
      {
        id: 9119,
        value: '休闲娱乐',
        children: [
          {
            id: 911901,
            value: '演出'
          },
          {
            id: 911902,
            value: '电影'
          },
          {
            id: 911903,
            value: '宠物'
          },
          {
            id: 911904,
            value: '星座/运势'
          },
          {
            id: 911905,
            value: '摄影'
          },
          {
            id: 911906,
            value: '娱乐八卦'
          }
        ]
      },
      {
        id: 9120,
        value: '视频音乐',
        children: [
          {
            id: 912001,
            value: '音乐'
          },
          {
            id: 912002,
            value: '视频'
          },
          {
            id: 912003,
            value: '播放工具'
          }
        ]
      },
      {
        id: 9121,
        value: '社交通讯',
        children: [
          {
            id: 912101,
            value: '网络通讯'
          },
          {
            id: 912102,
            value: '婚恋交友'
          },
          {
            id: 912103,
            value: '社区论坛'
          },
          {
            id: 912104,
            value: '问答'
          }
        ]
      },
      {
        id: 9122,
        value: '生活服务',
        children: [
          {
            id: 912201,
            value: '家政服务'
          },
          {
            id: 912202,
            value: '按摩'
          },
          {
            id: 912203,
            value: '美甲/美发/美容'
          },
          {
            id: 912204,
            value: '搬家'
          },
          {
            id: 912205,
            value: '快递'
          },
          {
            id: 912206,
            value: '物流'
          },
          {
            id: 912207,
            value: '分类信息'
          },
          {
            id: 912208,
            value: '婚庆'
          }
        ]
      },
      {
        id: 9123,
        value: '房产',
        children: [
          {
            id: 912301,
            value: '房屋租售'
          },
          {
            id: 912302,
            value: '装修'
          }
        ]
      },
      {
        id: 9124,
        value: '商务服务',
        children: [
          {
            id: 912401,
            value: '求职招聘'
          },
          {
            id: 912402,
            value: '人脉管理'
          },
          {
            id: 912403,
            value: '商务沟通'
          },
          {
            id: 912404,
            value: '营销运营'
          }
        ]
      },
      {
        id: 9125,
        value: '阅读',
        children: [
          {
            id: 912501,
            value: '小说'
          },
          {
            id: 912502,
            value: '杂志'
          },
          {
            id: 912503,
            value: '漫画'
          },
          {
            id: 912504,
            value: '搞笑'
          },
          {
            id: 912505,
            value: '阅读软件'
          }
        ]
      },
      {
        id: 9126,
        value: '新闻资讯',
        children: [
          {
            id: 912601,
            value: '科技'
          },
          {
            id: 912602,
            value: '财经'
          },
          {
            id: 912603,
            value: '法律'
          },
          {
            id: 912604,
            value: '家居'
          },
          {
            id: 912605,
            value: '时尚'
          },
          {
            id: 912606,
            value: '健康'
          },
          {
            id: 912607,
            value: '文学与艺术'
          },
          {
            id: 912608,
            value: '情感与两性'
          },
          {
            id: 912609,
            value: '房产建筑'
          }
        ]
      },
      {
        id: 9127,
        value: '实用工具',
        children: [
          {
            id: 912701,
            value: '系统类'
          },
          {
            id: 912702,
            value: '生活类'
          },
          {
            id: 912703,
            value: '影像类'
          },
          {
            id: 912704,
            value: '手机美化类'
          }
        ]
      },
      {
        id: 9128,
        value: '主题壁纸'
      },
      {
        id: 9118,
        value: '其他软件'
      }
    ]
  },
  {
    id: 92,
    value: '游戏',
    children: [
      {
        id: 9201,
        value: '休闲益智'
      },
      {
        id: 9202,
        value: '体育竞技'
      },
      {
        id: 9203,
        value: '动作射击'
      },
      {
        id: 9204,
        value: '棋牌桌游'
      },
      {
        id: 9205,
        value: '模拟辅助'
      },
      {
        id: 9206,
        value: '经营养成'
      },
      {
        id: 9207,
        value: '角色扮演'
      },
      {
        id: 9208,
        value: '赛车竞速'
      },
      {
        id: 9209,
        value: '其他游戏'
      },
      {
        id: 9210,
        value: '策略游戏'
      },
      {
        id: 9211,
        value: '街机游戏'
      },
      {
        id: 9212,
        value: '儿童游戏'
      },
      {
        id: 9213,
        value: '游戏大厅'
      }
    ]
  }
]
